type ReferEarnEntryTransitionListener = () => void;

let cashGiftTransitionActive = false;
const cashGiftTransitionListeners = new Set<ReferEarnEntryTransitionListener>();

export const getReferEarnEntryCashGiftTransitionActive = () =>
  cashGiftTransitionActive;

export const subscribeReferEarnEntryCashGiftTransition = (
  listener: ReferEarnEntryTransitionListener,
) => {
  cashGiftTransitionListeners.add(listener);
  return () => {
    cashGiftTransitionListeners.delete(listener);
  };
};

export const setReferEarnEntryCashGiftTransitionActive = (active: boolean) => {
  if (cashGiftTransitionActive === active) {
    return;
  }

  cashGiftTransitionActive = active;
  cashGiftTransitionListeners.forEach(listener => listener());
};
